import { InjectionToken, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { UserService } from '../services/user.service';

// Anticipate guard based on service only

export function canActivateForServiceParameter(serviceCode: string, parameterName: string, parameterValue: string) {
	return new InjectionToken<CanActivateFn>('ServiceGuardForServiceParameter', {
		providedIn: 'root',
		factory: () => {
			const userService = inject(UserService);
			return (_route, _state) =>
				userService.user.hasServiceParameterEqualsTo(serviceCode, parameterName, parameterValue);
		},
	});
}
